import { getStoreState } from 'config/store'
import { NEW_CONVERSATION_ID,PRERENDERED_CONVO_ID } from 'constants/conversations'
import { isNil, pathOr, values } from 'ramda'
import { ConversationId } from 'types/conversation'
import { Message, MessageAuthorType } from 'types/message'
import { isNilOrEmpty } from 'utils'

export const isPrerenderedConversation = (conversationId: ConversationId) => {
  return conversationId === PRERENDERED_CONVO_ID
}

export const isNewConversation = (conversationId: ConversationId) => {
  return conversationId === NEW_CONVERSATION_ID
}

export const conversationHasEndUserMessage = (currentMessage: Message) => {
  const messagesById = pathOr<Record<string, Message>>(null, ['conversations', 'messages', currentMessage.conversationId.toString()], getStoreState())
  return messagesById && values(messagesById)
    .some((message: Message) =>
      message.authorType !== MessageAuthorType.USER &&
      !!message.body &&
      message.id !== currentMessage.id
    )
}

export const isConversationIdNullOrPreRendered = (id) => {
  return isNilOrEmpty(id) || isPrerenderedConversation(id)
}

export const getConvoIdFromMessage = (message: Message)=>{
  let conversationId = message.conversationId

  if (conversationId === 0) {
    conversationId = PRERENDERED_CONVO_ID
  }

  if (isNil(conversationId)) {
    conversationId = NEW_CONVERSATION_ID
  }

  return conversationId
}
